import React from 'react';
import { Smile, Bot, Zap, Lightbulb } from 'lucide-react';
import { getVirtualRival, ZENDA_COACH, ZENDA_COACH_ID } from '../constants/virtualRivals';

interface RobotAvatarProps {
  robotId: string;
  className?: string;
  size?: number;
}

export const RobotAvatar: React.FC<RobotAvatarProps> = ({ robotId, className = "", size = 24 }) => {
  const profile = robotId === ZENDA_COACH_ID ? ZENDA_COACH : getVirtualRival(robotId);

  const Icon = profile.icon === 'smile' ? Smile :
               profile.icon === 'zap' ? Zap :
               profile.icon === 'lightbulb' ? Lightbulb :
               Bot;
  
  return (
    <div className={`flex items-center justify-center rounded-full ${profile.avatarColor} ${className}`} style={{ width: size * 1.5, height: size * 1.5 }}>
      <Icon size={size} className="text-white" />
    </div>
  );
};
